var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'articulos')?_c('div',{staticClass:"m-t-10"},[_c('filtros'),_c('graficos'),_c('totales'),_c('lista')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }